import Cookies from 'js-cookie'

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

const languageKey = 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// User
const tokenKey = 'vue_typescript_admin_access_token'
const refreshTokenKey = 'vue_typescript_admin_refresh_token'
export const getToken = () => Cookies.get(tokenKey)
export const getRefreshToken = () => Cookies.get(refreshTokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token)
export const setRefreshToken = (refreshToken: string) => Cookies.set(refreshTokenKey, refreshToken)
export const removeToken = () => Cookies.remove(tokenKey)
export const removeRefreshToken = () => Cookies.remove(refreshTokenKey)
